export enum State {
	WORK_IN_PROGRESS,
	COMPLETE,
	LAB_PROCESSING
}
export enum CarrierType {
	MIX2SEQ = "Mix2Seq",
	PLATE_CARRIER = "PLATE_CARRIER",
	TUBE_RACK = "TUBE_RACK",
	TUBE_CARRIER = "TUBE_CARRIER",
	SR_TUBE_CARRIER = "SR_TUBE_CARRIER",
	HAMILTON_CARRIER = "HAMILTON_CARRIER",
	UNPURIFIED_PCR = "UNPURIFIED_PCR",
	PREMIXED_DNA = "PREMIXED_DNA",
	READY_TO_LOAD = "READY_TO_LOAD",
	PURIFIED_DNA = "PURIFIED_DNA",
	CLONE = "CLONE",

	HAMILTON_RACK = "HAMILTON_RACK"
}
export enum ScannerType {
	HAMILTON,
	FLATBED,
	HANDSCANNER
}

export enum WellType {
	WELL96 = "96-Well",
	WELL384 = "384-Well"
}
/**
 * MaterialType restricts the type of material to be
 * Sample, QCSample, Primer, Chemical
 * 
 * @author Ayan Saha
*/
export enum MaterialType {
	Sample = 'Sample',
	QCSample = 'QCSample',
	Primer = 'Primer',
	Chemical = 'Chemical',
	Undefined = 'Undefined'
}

